module.exports = __webpack_public_path__ + "img/primary.d54e553f.svg";